// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ugKe","label":"styles_label__1Lv6X"};